import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-panel-generico',
  templateUrl: './panel-generico.component.html',
  styleUrls: ['./panel-generico.component.css']
})
export class PanelGenericoComponent implements OnInit {

  constructor() { }

  // tslint:disable-next-line: member-ordering
  @Input() titulo: string;
// tslint:disable-next-line: member-ordering
  @Input() icon: string = null;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/body-fieldset/panel-generico.component.ts